import React, { useState } from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import { CustomLableButton } from "../../Utils/CustomButton/CustomButton";

export default function AllEmployeesTable({ props, width }) {
  const [stateElem] = useState(
    Object.entries(props).slice(0, Object.keys(props)?.length - 1)
  );
  console.log(width);

  return (
    <Container>
      {stateElem.map((data, index) => (
        <>
          {data[1] === "فعال" ? (
            <Text myWidth={width[index]}>
              <ActiveStatus>{data[1]}</ActiveStatus>
            </Text>
          ) : data[1] === "غیر فعال" ? (
            <Text myWidth={width[index]}>
              <InActiveStatus>{data[1]}</InActiveStatus>
            </Text>
          ) : (
            <Text myWidth={width[index]}>{data[1]}</Text>
          )}
        </>
      ))}
      {props.buttonImg.map((data) => (
        <CustomLableButton Img={data} Dis="2rem" />
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  border: 2px solid ${Theme.colorBorderTextField};
  margin: 1rem;
  padding: 0 1rem;
  border-radius: 8px;
`;

const Text = styled.p`
  color: ${Theme.colorFontBlack};
  font-size: ${Theme.fontSiz};
  font-weight: ${Theme.fontWeigh};
  width: ${(props) => props.myWidth};
  margin: 0.7rem 0;
`;

const ActiveStatus = styled.div`
  width: 70px;
  border-radius: ${Theme.borderRadius};
  padding: 5px 0.5rem;
  background-color: #bdeecf;
  color: #147638;
  text-align: center;
`;

const InActiveStatus = styled.div`
  width: 70px;
  border-radius: ${Theme.borderRadius};
  padding: 5px 0.5rem;
  background-color: #fac7c7;
  color: #8F2929;
  text-align: center;
`;
